import React from 'react';

const Logo = () => {
    return (
        <div className="logo">
            <img
                src="https://www.ooppah.com.br/themes/bootstrap/img/logo.png"
                alt="Ooppah Logo"
            />
        </div>
    );
};

export default Logo;